module.exports = __webpack_public_path__ + "1.5.0-unryo/img/riverbed.dd2598a8.svg";